// The moment locales the app supports, for both places that format dates: the page (main.ts) and the
// export builder, which also runs inside export.worker and shares nothing with the page.
//
// Registering a locale also makes it moment's global one, so the global is put back to 'en' at the end:
// the page's comes from I18nService, and the worker never learns it, so format there with an explicit
// instance locale. Not in the utils barrel on purpose: it is a side effect, and the barrel would drag
// every util into the worker's chunk.
import 'moment/locale/ca';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/en-gb';
import 'moment/locale/en-ie';
import 'moment/locale/en-nz';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/nb';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/zh-tw';
import moment from 'moment-timezone';

moment.locale('en');
